import { useState } from 'react';
import Hero from '../components/Hero';
import Offers from '../components/Offers';
import Process from '../components/Process';
import Coverage from '../components/Coverage';
import Contact from '../components/Contact';
import Footer from '../components/Footer';
import ChatWidget from '../components/ChatWidget';
import IntroScreen from '../components/IntroScreen';

const Landing = () => {
  const [entered, setEntered] = useState(false);

  return (
    <>
      {!entered && <IntroScreen onEnter={() => setEntered(true)} />}
      {entered && (
        <>
          <Hero />
          <Offers />
          <Process />
          <Coverage />
          <Contact />
          <Footer />
          <ChatWidget />
        </>
      )}
    </>
  );
};

export default Landing;
